export default {

	appTitle: process.env.VUE_APP_APP_NAME,

};
